import React, { useState, useEffect } from "react";
import NavBar from "../../layout/navbar/navbar";
import { FaHandPointRight } from "react-icons/fa";
import { BiAnalyse } from "react-icons/bi";
import { IoMdClose } from "react-icons/io";
import { Alert, Button, Container, Spinner } from "react-bootstrap";
import { useSupabaseApp } from "../../SupabaseApp";
import "./dashboard.css";
import OneColFeedDisplay from "./rss-feed";

/**
 * PrnewsireFin Component (Corporate Press Release Page)
 * 
 * Displays corporate press releases from PR Newswire in a paginated news feed format.
 * Shows loading and alert states, and renders the OneColFeedDisplay component to display
 * press release articles. Requires user authentication.
 * 
 * @returns {JSX.Element} Page layout with navigation bar, alert system, and CPR news feed
 */
const PrnewsireFin = () => {
  // Get user context from Supabase authentication
  const { currentUser, logInAnonymous, supabase } = useSupabaseApp();

  // Check if user is logged in before rendering
  if (!currentUser) {
    throw new Error(`Must be logged in`);
  }

  // State to control alert component visibility
  const [alert, setAlert] = useState(true);

  // State to store alert message content (initially shows loading message)
  const [message, setMessage] = useState(
    <div style={{ display: "flex", paddingTop: "10px" }}>
      <div style={{ width: "90%" }}>
        <p style={{ color: "#0f9d58" }}>
          <BiAnalyse className="alert-icon" /> Loading
        </p>
        <p style={{ marginLeft: "28px", fontSize: "14px" }}>
          Won't be long now. We're always doing our best to reduce waiting time.
        </p>
        <p style={{ marginLeft: "28px", fontSize: "14px" }}>
          If your waiting time is too long,{" "}
          <a
            href="https://www.roiquant.com/contact"
            target="_blank"
            rel="noopener noreferrer"
          >
            contact us
          </a>
          .
        </p>
      </div>
      <div style={{ width: "10%", textAlign: "right" }}>
        <Spinner animation="border" variant="secondary" />
      </div>
    </div>
  );

  // Close the alert by hiding it and clearing the message
  function closeAlert() {
    setAlert(false);
    setMessage("");
  }

  return (
    <>
      <NavBar />

      {alert ? (
        <Alert className="error-message floating-alert" variant="light">
          <div>
            <div style={{ textAlign: "right" }}>
              <Button className="pitchdeckmessageclose" onClick={closeAlert}>
                <IoMdClose />
              </Button>
            </div>
            {message}
          </div>
        </Alert>
      ) : (
        ""
      )}

      <div id="dashboard">
        <Container fluid style={{ width: "90%", paddingBottom: "60px" }}>
          <OneColFeedDisplay
            setAlert={setAlert}
            setMessage={setMessage}
            closeAlert={closeAlert}
          />
        </Container>
      </div>
    </>
  );
};

export default PrnewsireFin;
